import { useNavigate } from "react-router-dom";
import { useEffect, ReactElement } from "react";
import routeConstants from "../utils/routeConstants";
import useAuth from "../hooks/useAuth";
import { GuestGuardProps } from "../types/AuthTypes";

const GuestGuard = ({ children }: GuestGuardProps): ReactElement => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth(); // Needed in future

  useEffect(() => {
    if (isAuthenticated) {
      navigate(routeConstants.dashboard);
    }
  }, [isAuthenticated, navigate]);

  return children as ReactElement;
};

export default GuestGuard;
